import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Checkbox,
  Icon,
  IconButton,
  MenuItem,
  Popover,
  Table,
  TableBody,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import CheckBoxOutlined from "@mui/icons-material/CheckBoxOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import {
  dateFormate,
  getDateComparision,
  getDateFormat,
  truncateComment,
} from "utils/utils";
import { StyledTableCell, StyledTableRow } from "./CommonTableStyle";
import editmore from "assets/images/moreEditIcon.svg";
import preview from "assets/images/Preview.svg";
import cancel from "assets/images/CancelDuty.svg";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import labelIcon from 'assets/images/labelIcon.svg';
import PlacardModal from 'components/placardModal/PlacardModal';

const CommonTable = (props) => {
  const {
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    moreIconData,
  } = props;
  let data = props?.data;

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCheckRows, setSelectedCheckRows] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedTripId, setSelectedTripId] = useState("");

  const handleMenuOpen = (event, row) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const onClickTableRow = (val) => {
    props?.tableOnClickRow && props?.tableOnClickRow(navigate, val);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getConditionalMenuItems = (status) => {
    if (props?.tabName === "Billing") {
      return ["Duty Slip", "Proforma Invoice", "Reject"];
    } else {
      switch (status?.toLowerCase()) {
        case "booked":
        case "alloted":
        case "pending":
          return ["Edit", "Cancel"];
        case "ongoing":
        return ["Request Extension"];
        default:
          return [];
      }
    }
  };

  const onClickMoreIcon = (event, data, type) => {
    event.preventDefault();
    event.stopPropagation();
    props?.onClickMoreIcon(data, type);
    handleMenuClose();
  };

  const moreIconSrc = (value) => {

    switch (value?.toLowerCase()) {
      case "edit":
        return editmore;
      case "cancel":
      case "reject":
        return cancel;
      case "preview":
      case "duty slip":
      case "proforma invoice":
        return preview;
      default:
        return;
    }
  };

  const handleCheckboxChange = (row) => {
    if (selectedCheckRows.includes(row)) {
      // If the row is already selected, unselect it
      setSelectedCheckRows(
        selectedCheckRows.filter((selectedRow) => selectedRow !== row)
      );
      props?.setSelectedCheckRows(
        selectedCheckRows.filter((selectedRow) => selectedRow !== row)
      );
      setSelectAllChecked(false); // Uncheck the header checkbox
    } else {
      // If the row is not selected, select it
      setSelectedCheckRows([...selectedCheckRows, row]);
      props?.setSelectedCheckRows([...selectedCheckRows, row]);

      // Check if all rows are selected
      const allRowsSelected = data.body.every((item) =>
        selectedCheckRows.includes(item)
      );
      setSelectAllChecked(allRowsSelected); // Update the header checkbox
    }
  };

  const handleSelectAllCheckboxChange = () => {
    if (selectAllChecked) {
      setSelectedCheckRows([]);
      props?.setSelectedCheckRows([]);
    } else {
      setSelectedCheckRows(data.body);
      props?.setSelectedCheckRows(data.body);
    }
    setSelectAllChecked(!selectAllChecked);
  };

  //disable Edit option
  const handleDisableEdit = (tabName, icon, time) => {
    if (tabName === "booking" && icon === "Edit" && !getDateComparision(time)) {
      return true;
    }
  };

  //enabling moreVertIcon 
  const handleMoreVertIcon = (status) => {
    const defaultStatus = ["completed", "cancelled", "dispatched", "closed"]

    if(!defaultStatus.includes(status?.toLowerCase())) {
      return "active"
    }
  }

     const handlePreviewOpen = (placardText, id, e) => {
    e.stopPropagation();
    if (id) {
      setSelectedTripId(id);
      setPreviewModal(true);
    }
  };

  const handlePreviewClose = () => {
    setSelectedImage("");
    setPreviewModal(false);
  };

  return (
    <div>
      <TableContainer className={`tableMain`}>
        <Table
          sx={{ [`& .${tableCellClasses.root}`]: { borderBottom: "none" } }}
          aria-label="customized table"
        >
          <TableHead className="tableborder">
            <TableRow className="commonTableRow">
              {data?.header?.map((ele, index) => (
                <StyledTableCell
                  key={index}
                  align="left"
                  className={`comColumnWidth font16 fw500`}
                >
                  {ele.key === "check" ? (
                    <Checkbox
                      className="headerOutlinedCheckbox"
                      checked={selectAllChecked}
                      checkedIcon={
                        <Icon>
                          <CheckBoxOutlined />
                        </Icon>
                      }
                      onChange={handleSelectAllCheckboxChange}
                    />
                  ) : (
                    ele?.label
                  )}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="tableBodyStyle">
            {data?.body?.length ? (
              data?.body?.map((ele, ind) => (
                <StyledTableRow
                  key={ind}
                  role="presentation"
                  disabled={ele.status === "Blocked"}
                  className={`comRowChildWidth font18 ${
                    ele.isVip && "vipRow"
                  } ${ele.gender === "Female" && "femaleGenderRow"}`}
                >
                  {data?.header?.map((val, index) => (
                    <StyledTableCell
                      align="left"
                      key={index}
                      disabled={ele.status === "Blocked"}
                      onClick={() => onClickTableRow(ele)}
                    >
                      {val.label === "Booking ID" ? (
                        <Typography variant={"body2"}>
                          {ele["tripId"] || ""}
                        </Typography>
                      ) : val.key === "sourceAddress" ||
                        val.key === "destinationAddress"  || 
                        val.key === "sourceLandMarkAddress" ||
                        val.key === "branchAddress" ? (
                        <Box>
                          <Tooltip title={ele[val.key]} placement="bottom">
                            <Typography variant={"body2"}>
                              {ele[val.key]
                                ? truncateComment(ele[val.key], 15)
                                : "NA"}
                            </Typography>
                          </Tooltip>
                        </Box>
                      ) : val.label === "Trip Date" ? (
                        <Box>
                          <Typography variant={"body2"}>
                            {ele?.scheduledTime
                              ? getDateFormat(ele?.scheduledTime, "date")
                              : "NA"}
                          </Typography>
                        </Box>
                      ) : val.label === "Reporting Time" ? (
                        <Box>
                          <Typography variant={'body2'}>
                            {dateFormate(ele['scheduledTime'], 'DD MMM YYYY, hh:mm a')}
                          </Typography>
                        </Box>
                      ) : val.key === "check" ? (
                        <Checkbox
                          className="bodyOutlinedCheckbox"
                          checkedIcon={
                            <Icon>
                              <CheckBoxOutlined />
                            </Icon>
                          }
                          checked={
                            selectAllChecked || selectedCheckRows.includes(ele)
                          }
                          onChange={() => handleCheckboxChange(ele)}
                        />
                      ) : val.key === "customerName" ? (
                        <Box>
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            onClick={(event) => onClickTableRow(event, ele)}
                          >
                            <Tooltip title={ele[val.key]} placement="bottom">
                              <Typography variant={"body2"}>
                                {ele[val.key]
                                  ? truncateComment(ele[val.key], 10)
                                  : "NA"}
                              </Typography>
                            </Tooltip>
                            {ele?.additionalInfo?.placard?.text && (
                              <Tooltip title="View Placard" placement="bottom">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handlePreviewOpen(
                                      ele?.additionalInfo?.placard?.text,
                                      ele?.id,
                                      e
                                    );
                                  }}
                                  sx={{ padding: '4px' }}
                                >
                                  <img 
                                    src={labelIcon} 
                                    alt="Placard"
                                    style={{ 
                                      width: '20px',
                                      height: '20px'
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                            )}
                            {ele.isVip && (
                            <Box className="ml5">
                              <Typography
                              variant={"body6"}
                              className="vipBadge colorWhite"
                            >
                              VIP
                            </Typography>
                            </Box>
                            )}
                          </Box>
                          <Typography
                            variant={"body4"}
                            className="colorGrey"
                            component={"p"}
                          >
                            {ele["gender"]}
                          </Typography>
                        </Box>
                      ) : val.label === "Rep. Time" ? (
                        <Box>
                          <Typography variant={"body2"}>
                            {ele?.scheduledTime
                              ? getDateFormat(ele?.scheduledTime, "time")
                              : "NA"}
                          </Typography>
                        </Box>
                      ) : val.key === "status" ? (
                        <Box>
                          <Typography
                            variant={"body2"}
                            id={`status-text-${ind}`}
                            className={`${ele.status?.toLowerCase()}Status `}
                          >
                            {ele[val.key]}
                          </Typography>
                        </Box>
                      ) : val.key === "icon" && handleMoreVertIcon(ele["status"]) ? (
                        <IconButton
                          onClick={(event) => handleMenuOpen(event, ele)}
                        >
                          <div className="colorBlack">{<MoreVertIcon />}</div>
                        </IconButton>
                      ) : (
                        <Box>
                          <Typography variant={"body2"}>
                            {ele[val.key]}
                          </Typography>
                        </Box>
                      )}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <StyledTableCell colSpan={data?.header?.length} align="center">
                  <CommonNoDataFound />
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {data?.body?.length && data?.totalCount > 10 ? (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={data?.totalCount && Number(data?.totalCount)}
          rowsPerPage={Number(rowsPerPage)}
          page={Number(page)}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      ) : null}
      <Popover
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        className="tablePopover"
        onClose={() => handleMenuClose()}
      >
        {moreIconData && moreIconData.length > 0
          ? // Render the menu items using moreIconData if it is available
            moreIconData.map((moreData, idx) => (
              <MenuItem
                onClick={(e) => onClickMoreIcon(e, selectedRow, moreData?.name)}
                selected={selectedItem === moreData?.name}
                key={idx}
              >
                {moreIconSrc(moreData?.name)?.length > 0 && (
                  <span className="mr10 alignItemsCenter">
                    <img
                      src={moreIconSrc(moreData?.name)}
                      alt={moreData?.name}
                    />
                  </span>
                )}
                <Typography variant={"body2"} className="fw500">
                  {moreData?.name}
                </Typography>
              </MenuItem>
            ))
          : // Render the custom menu items if moreIconData is not available
            getConditionalMenuItems(selectedRow?.status)
              ?.filter((obj) => obj !== "vip")
              ?.map((moreData, idx) => (
                <Box
                  key={idx}
                  className={
                    handleDisableEdit(
                      props?.tabName,
                      moreData,
                      selectedRow?.scheduledTime
                    ) && "cursorDisabled"
                  }
                >
                  <MenuItem
                    onClick={(e) => onClickMoreIcon(e, selectedRow, moreData)}
                    selected={selectedItem === moreData}
                    key={moreData}
                    disabled={handleDisableEdit(
                      props?.tabName,
                      moreData,
                      selectedRow?.scheduledTime
                    )}
                    className="customPointerEvents p10"
                  >
                    {moreIconSrc(moreData)?.length > 0 && (
                      <span className="mr10 alignItemsCenter tabIcon">
                        <img
                          src={moreIconSrc(moreData)}
                          alt={moreData}
                          className="width20"
                        />
                      </span>
                    )}
                    <Typography variant={"body2"} className="fw500">
                      {moreData}
                    </Typography>
                  </MenuItem>
                </Box>
              ))}
      </Popover>
            {previewModal && (
  <PlacardModal
    open={previewModal}
    handleClose={handlePreviewClose}
    tripId={selectedTripId}
  />
)}
    </div>
  );
};

export default CommonTable;
